import { StrictMode, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { TamaguiProvider } from '@shinkansen/sakura'
import { sakuraConfig } from '@shinkansen/sakura/config'
import { AuthProvider } from './auth'
import { routeTree } from './routes'
import { ThemeProvider, useThemeController } from './theme'
import './styles/global.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      refetchOnWindowFocus: false,
    },
  },
})

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

function AppProviders({ children }: { children: ReactNode }) {
  const theme = useThemeController()

  return (
    <TamaguiProvider config={sakuraConfig} defaultTheme={theme.theme}>
      <ThemeProvider value={theme}>{children}</ThemeProvider>
    </TamaguiProvider>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </AuthProvider>
    </AppProviders>
  </StrictMode>
)
